// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__30kR2","content":"LayoutSettings_content__hklh6"};